import React from 'react'
import { Button } from 'vnetwork-ui'

export interface Action {
    label: string
    icon?: React.ReactNode
    onClick: () => void
    color?: 'default' | 'primary' | 'secondary' | 'error' | 'success' | 'info'
    variant?: 'text' | 'outlined' | 'contained'
    disabled?: boolean
    rsname?: string // Optional resource name
    require_scopes?: string[] // Optional required scopes
    visible_permission_denied?: boolean
    'data-tour'?: string // Optional tour step identifier
}

interface ActionsProps {
    actions: Action[]
    className?: string
    components?: React.ReactNode[]
}

const ButtonGroupActions: React.FC<ActionsProps> = ({
    actions,
    className = '',
    components = [],
}) => {
    if (actions.length === 0 && components.length === 0) return null

    return (
        <div
            className={`px-4 py-2 mt-1 flex gap-8 bg-white rounded-[8px] ${className}`}
        >
            <div className="flex items-center gap-2 flex-1 justify-end flex-wrap">
                {actions.map((action, index) => {
                    const dataTour = action['data-tour']

                    // Define the button component
                    const ActionButton = (
                        <Button
                            onClick={action.onClick}
                            startIcon={action.icon}
                            color={action.color || 'primary'}
                            variant={action.variant || 'contained'}
                            disabled={action.disabled}
                            className="w-full md:w-auto"
                        >
                            {action.label}
                        </Button>
                    )

                    // Wrap with data-tour div if specified
                    if (dataTour) {
                        return (
                            <div key={index} data-tour={dataTour}>
                                {ActionButton}
                            </div>
                        )
                    }

                    return (
                        <React.Fragment key={index}>
                            {ActionButton}
                        </React.Fragment>
                    )
                })}

                {components.map((component, index) => (
                    <React.Fragment key={index}>{component}</React.Fragment>
                ))}
            </div>
        </div>
    )
}

export default ButtonGroupActions
